/**
 * @fileoverview gRPC-Web generated client stub for admpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: admpb/calendar.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.admpb = require('./calendar_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.CalendarServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.admpb.CalendarServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.ListCalendarRequest,
 *   !proto.admpb.ListCalendarResponse>}
 */
const methodDescriptor_CalendarService_ListCalendar = new grpc.web.MethodDescriptor(
  '/admpb.CalendarService/ListCalendar',
  grpc.web.MethodType.UNARY,
  proto.admpb.ListCalendarRequest,
  proto.admpb.ListCalendarResponse,
  /**
   * @param {!proto.admpb.ListCalendarRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.ListCalendarResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.ListCalendarRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.ListCalendarResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.ListCalendarResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.CalendarServiceClient.prototype.listCalendar =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.CalendarService/ListCalendar',
      request,
      metadata || {},
      methodDescriptor_CalendarService_ListCalendar,
      callback);
};


/**
 * @param {!proto.admpb.ListCalendarRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.ListCalendarResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.CalendarServicePromiseClient.prototype.listCalendar =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.CalendarService/ListCalendar',
      request,
      metadata || {},
      methodDescriptor_CalendarService_ListCalendar);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.GetPreviousSettleDateRequest,
 *   !proto.admpb.GetPreviousSettleDateResponse>}
 */
const methodDescriptor_CalendarService_GetPreviousSettleDate = new grpc.web.MethodDescriptor(
  '/admpb.CalendarService/GetPreviousSettleDate',
  grpc.web.MethodType.UNARY,
  proto.admpb.GetPreviousSettleDateRequest,
  proto.admpb.GetPreviousSettleDateResponse,
  /**
   * @param {!proto.admpb.GetPreviousSettleDateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.GetPreviousSettleDateResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.GetPreviousSettleDateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.GetPreviousSettleDateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.GetPreviousSettleDateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.CalendarServiceClient.prototype.getPreviousSettleDate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.CalendarService/GetPreviousSettleDate',
      request,
      metadata || {},
      methodDescriptor_CalendarService_GetPreviousSettleDate,
      callback);
};


/**
 * @param {!proto.admpb.GetPreviousSettleDateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.GetPreviousSettleDateResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.CalendarServicePromiseClient.prototype.getPreviousSettleDate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.CalendarService/GetPreviousSettleDate',
      request,
      metadata || {},
      methodDescriptor_CalendarService_GetPreviousSettleDate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.admpb.GetPreviousTradeDateRequest,
 *   !proto.admpb.GetPreviousTradeDateResponse>}
 */
const methodDescriptor_CalendarService_GetPreviousTradeDate = new grpc.web.MethodDescriptor(
  '/admpb.CalendarService/GetPreviousTradeDate',
  grpc.web.MethodType.UNARY,
  proto.admpb.GetPreviousTradeDateRequest,
  proto.admpb.GetPreviousTradeDateResponse,
  /**
   * @param {!proto.admpb.GetPreviousTradeDateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.admpb.GetPreviousTradeDateResponse.deserializeBinary
);


/**
 * @param {!proto.admpb.GetPreviousTradeDateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.admpb.GetPreviousTradeDateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.admpb.GetPreviousTradeDateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.admpb.CalendarServiceClient.prototype.getPreviousTradeDate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/admpb.CalendarService/GetPreviousTradeDate',
      request,
      metadata || {},
      methodDescriptor_CalendarService_GetPreviousTradeDate,
      callback);
};


/**
 * @param {!proto.admpb.GetPreviousTradeDateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.admpb.GetPreviousTradeDateResponse>}
 *     Promise that resolves to the response
 */
proto.admpb.CalendarServicePromiseClient.prototype.getPreviousTradeDate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/admpb.CalendarService/GetPreviousTradeDate',
      request,
      metadata || {},
      methodDescriptor_CalendarService_GetPreviousTradeDate);
};


module.exports = proto.admpb;

